"use strict";

require("core-js/modules/es6.object.define-property");

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var styled_components_1 = __importStar(require("styled-components"));

exports.FlexBox = styled_components_1["default"].div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  display: flex;\n  text-align: left;\n\n  ", "\n\n  ", "\n\n  // if the container itself is part of an other container\n  ", "\n\n  ", "\n\n"], ["\n  display: flex;\n  text-align: left;\n\n  ", "\n\n  ", "\n\n  // if the container itself is part of an other container\n  ", "\n\n  ", "\n\n"])), function (_a) {
  var flexDirection = _a.flexDirection;
  return "flex-direction: " + flexDirection + ";";
}, function (_a) {
  var align = _a.align;
  return "align-items: " + align + ";";
}, function (_a) {
  var flex = _a.flex;
  return flex && styled_components_1.css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      flex: ", ";\n    "], ["\n      flex: ", ";\n    "])), flex);
}, function (_a) {
  var justify = _a.justify;
  return justify && styled_components_1.css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n      justify-content: ", ";\n    "], ["\n      justify-content: ", ";\n    "])), justify);
});
var templateObject_1, templateObject_2, templateObject_3;